/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { isMobile } from 'utils/helpers';
import InvoicesItem from 'components/Credit24/SelfService/Invoices/InvoicesItem';
import UnpaidInvoiceSection from 'components/Credit24/SelfService/Invoices/UnpaidInvoiceSection';
import UnpaidInvoiceSectionMobile from 'components/Credit24/SelfService/Invoices/UnpaidInvoiceSectionMobile';
import OpenInvoiceSectionMobile from 'components/Credit24/SelfService/Invoices/OpenInvoiceSectionMobile';

const propTypes = {
  invoices: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
};

class InvoicesSection extends Component {
  constructor() {
    super();
    this.getContent = this.getContent.bind(this);
  }

  getContent(hasLateFees) {
    const { invoices, contract } = this.props;

    const {
      openInvoices = [],
      unpaidInvoices = [],
      unpaidAmount,
      paidInvoices,
    } = invoices;
    const { lateFees } = contract;
    const showUnpaidInvoices = unpaidInvoices.length > 0 || hasLateFees;
    const openInvoice = openInvoices[0];

    if (showUnpaidInvoices) {
      if (isMobile) {
        return (
          <UnpaidInvoiceSectionMobile
            invoices={unpaidInvoices}
            contractId={contract.id}
            lateFees={hasLateFees ? lateFees : null}
          />
        );
      }

      return (
        <UnpaidInvoiceSection
          unpaidInvoices={unpaidInvoices}
          contractId={contract.id}
          unpaidAmount={unpaidAmount}
          lateFees={hasLateFees ? lateFees : null}
        />
      );
    }

    if (openInvoice && !isMobile) {
      return (
        <>
          <div className="invoices">
            <p className="invoices__text">
              <FormattedMessage id="selfservice.invoices.paymentDateInfo" />
            </p>
          </div>
          <InvoicesItem
            invoice={openInvoice}
            contractId={contract.id}
            showInvoiceNumber={COUNTRY !== 'AU'}
          />
        </>
      );
    }

    if (openInvoice && isMobile) {
      return (
        <OpenInvoiceSectionMobile
          invoice={openInvoice}
          contractId={contract.id}
        />
      );
    }

    const noInvoicesIconClasses = cx({
      message__icon: true,
      'message__icon--country-fi': COUNTRY === 'FI',
    });

    let invoiceText = 'selfservice.invoices.nextInvoiceDateAvailability';
    let invoiceDate = contract.nextInvoicingDate;

    if (COUNTRY === 'AU') {
      invoiceText = 'selfservice.invoices.firstInvoiceDateAvailability';
      invoiceDate = contract.nextDueDate;
    }

    return (
      <div className="message message--no-invoices">
        <span className={noInvoicesIconClasses} />
        {(contract.availableLimit > 0 || contract.product.type === 'INSTALLMENT')
          && (
          <div className="invoices">
            <FormattedMessage
              id={`selfservice.invoices.${!paidInvoices.length && COUNTRY === 'AU' ? 'nonePaidYet' : 'allPaid'}`}
              tagName="p"
            />
            <p className="invoices__text">
              <FormattedMessage
                id={invoiceText}
                values={{
                  formattedDate: moment(invoiceDate).format('L'),
                }}
              />
            </p>
          </div>
          )}
        {(!contract.availableLimit && contract.product.type === 'CREDIT_LINE')
          && (
          <span className="message__content">
            <FormattedMessage id="selfservice.invoices.allPaid" />
          </span>
          )}
      </div>
    );
  }

  render() {
    const { invoices, contract: { lateFees } } = this.props;
    const hasLateFees = COUNTRY === 'AU' && lateFees > 0;

    if (isEmpty(invoices) && !hasLateFees) {
      return null;
    }

    const { unpaidInvoices = [], openInvoices = [] } = invoices;

    const blockClasses = cx({
      'content-block': true,
      'content-block--type-warning': unpaidInvoices.length && !isMobile,
      'txt-center': isMobile,
    });
    const linkClasses = cx({
      'txt-right': !isMobile,
      'txt-center': isMobile,
    });

    let title = (
      <h3 className="content-block__title">
        <FormattedMessage id="selfservice.dashboard.invoice.paid" />
      </h3>
    );

    if (openInvoices.length) {
      title = isMobile ? false : (
        <h3 className="content-block__title">
          <FormattedMessage id="selfservice.dashboard.invoice.pending" />
        </h3>
      );
    }

    if (unpaidInvoices.length > 0 || hasLateFees) {
      const titleClasses = cx({
        'content-block__title': true,
        'content-block__title--type-warning': !isMobile,
        'txt-error': isMobile,
      });

      if (unpaidInvoices.length > 0) {
        title = (
          <h3 className={titleClasses}>
            <FormattedMessage
              id="selfservice.dashboard.invoice.unpaid"
              values={{
                value: unpaidInvoices.length,
                formattedValue: <strong>{unpaidInvoices.length}</strong>,
              }}
            />
          </h3>
        );
      } else {
        title = (
          <h3 className={titleClasses}>
            <FormattedMessage id="selfservice.dashboard.invoice.lateFee" />
          </h3>
        );
      }
    }

    return (
      <div className={blockClasses}>
        {title}
        {this.getContent(hasLateFees)}
        {COUNTRY !== 'AU'
          && (
          <div className={linkClasses}>
            <Link to="/invoices">
              <FormattedMessage id="selfservice.dashboard.linkToInvoices" />
            </Link>
          </div>
          )}
      </div>
    );
  }
}

InvoicesSection.propTypes = propTypes;

export default InvoicesSection;
